import { RegistrationLayout } from ".";

export const Ineligible = () => {
  return <RegistrationLayout sweeps ineligible />;
};
